import React from 'react';
import SidebarItem from './SidebarItem';
import items from '../../data/sidebarData';

const Sidebar = () => {
  return (
    <div className='sidebar overflow-y-auto h-[calc(100vh-180px)] md:h-[calc(100vh-94px)] transform transition-transform pt-12 !scrollbar-thin scrollbar-w-2 scrollbar-thumb-[#229698] scrollbar-track-pc-02 scrollbar-track-rounded-md scrollbar-thumb-rounded-md'>
      {items.map((item, index) => (
        <SidebarItem key={item?.href + item?.title} {...items} item={item} />
      ))}
    </div>
  );
};

export default Sidebar;
